import classnames from 'classnames';
import React from 'react';

import '@eika/card-style';
import { IconTypes } from '@eika/icon';
import { RichIconTypes } from '@eika/rich-icon';

import CardIcon from './CardIcon';
import CardIconSizes from './CardIconSizes';

export type CardProps = {
    title: string;
    isModal?: boolean;
    icon?: IconTypes | RichIconTypes | JSX.Element;
    iconSize?: CardIconSizes;
} & React.PropsWithoutRef<JSX.IntrinsicElements['div']>;

const Card = ({
    children,
    title,
    className,
    isModal,
    icon,
    iconSize,

    ...rest
}: CardProps): JSX.Element => (
    <div className={classnames(className, 'sgw-card', { 'sgw-card__common-card': !isModal })} {...rest}>
        {icon && <CardIcon icon={icon} iconSize={iconSize} />}
        <h3 className="sgw-card__title">{title}</h3>
        <div className="render">{children}</div>
    </div>
);

export default Card;
